var map = {
	"./AD.json": 1152,
	"./AE.json": 1153,
	"./AF.json": 1154,
	"./AG.json": 1155,
	"./AI.json": 1156,
	"./AL.json": 1157,
	"./AM.json": 1158,
	"./AO.json": 1159,
	"./AR.json": 1160,
	"./AS.json": 1161,
	"./AT.json": 1162,
	"./AU.json": 1163,
	"./AW.json": 1164,
	"./AX.json": 1165,
	"./AZ.json": 1166,
	"./BA.json": 1167,
	"./BB.json": 1168,
	"./BD.json": 1169,
	"./BE.json": 1170,
	"./BF.json": 1171,
	"./BG.json": 1172,
	"./BH.json": 1173,
	"./BI.json": 1174,
	"./BJ.json": 1175,
	"./BM.json": 1176,
	"./BN.json": 1177,
	"./BO.json": 1178,
	"./BR.json": 1179,
	"./BS.json": 1180,
	"./BT.json": 1181,
	"./BW.json": 1182,
	"./BY.json": 1183,
	"./BZ.json": 1184,
	"./CA.json": 1185,
	"./CD.json": 1186,
	"./CF.json": 1187,
	"./CG.json": 1188,
	"./CH.json": 1189,
	"./CI.json": 1190,
	"./CK.json": 1191,
	"./CL.json": 1192,
	"./CM.json": 1193,
	"./CN.json": 1194,
	"./CO.json": 1195,
	"./CR.json": 1196,
	"./CU.json": 1197,
	"./CV.json": 1198,
	"./CX.json": 1199,
	"./CY.json": 1200,
	"./CZ.json": 1201,
	"./DE.json": 1202,
	"./DJ.json": 1203,
	"./DK.json": 1204,
	"./DM.json": 1205,
	"./DO.json": 1206,
	"./DZ.json": 1207,
	"./EC.json": 1208,
	"./EE.json": 1209,
	"./EG.json": 1210,
	"./ER.json": 1211,
	"./ES.json": 1212,
	"./ET.json": 1213,
	"./FI.json": 1214,
	"./FJ.json": 1215,
	"./FK.json": 1216,
	"./FM.json": 1217,
	"./FO.json": 1218,
	"./FR.json": 1219,
	"./GA.json": 1220,
	"./GB.json": 1221,
	"./GD.json": 1222,
	"./GE.json": 1223,
	"./GF.json": 1224,
	"./GG.json": 1225,
	"./GH.json": 1226,
	"./GI.json": 1227,
	"./GL.json": 1228,
	"./GM.json": 1229,
	"./GN.json": 1230,
	"./GP.json": 1231,
	"./GQ.json": 1232,
	"./GR.json": 1233,
	"./GT.json": 1234,
	"./GU.json": 1235,
	"./GW.json": 1236,
	"./GY.json": 1237,
	"./HK.json": 1238,
	"./HN.json": 1239,
	"./HR.json": 1240,
	"./HT.json": 1241,
	"./HU.json": 1242,
	"./ID.json": 1243,
	"./IE.json": 1244,
	"./IL.json": 1245,
	"./IM.json": 1246,
	"./IN.json": 1247,
	"./IQ.json": 1248,
	"./IR.json": 1249,
	"./IS.json": 1250,
	"./IT.json": 1251,
	"./JE.json": 1252,
	"./JM.json": 1253,
	"./JO.json": 1254,
	"./JP.json": 1255,
	"./KE.json": 1256,
	"./KG.json": 1257,
	"./KH.json": 1258,
	"./KI.json": 1259,
	"./KM.json": 1260,
	"./KN.json": 1261,
	"./KP.json": 1262,
	"./KR.json": 1263,
	"./KW.json": 1264,
	"./KY.json": 1265,
	"./KZ.json": 1266,
	"./LA.json": 1267,
	"./LB.json": 1268,
	"./LC.json": 1269,
	"./LI.json": 1270,
	"./LK.json": 1271,
	"./LR.json": 1272,
	"./LS.json": 1273,
	"./LT.json": 1274,
	"./LU.json": 1275,
	"./LV.json": 1276,
	"./LY.json": 1277,
	"./MA.json": 1278,
	"./MC.json": 1279,
	"./MD.json": 1280,
	"./ME.json": 1281,
	"./MG.json": 1282,
	"./MH.json": 1283,
	"./MK.json": 1284,
	"./ML.json": 1285,
	"./MM.json": 1286,
	"./MN.json": 1287,
	"./MO.json": 1288,
	"./MP.json": 1289,
	"./MQ.json": 1290,
	"./MR.json": 1291,
	"./MS.json": 1292,
	"./MT.json": 1293,
	"./MU.json": 1294,
	"./MV.json": 1295,
	"./MW.json": 1296,
	"./MX.json": 1297,
	"./MY.json": 1298,
	"./MZ.json": 1299,
	"./NA.json": 1300,
	"./NC.json": 1301,
	"./NE.json": 1302,
	"./NF.json": 1303,
	"./NG.json": 1304,
	"./NI.json": 1305,
	"./NL.json": 1306,
	"./NO.json": 1307,
	"./NP.json": 1308,
	"./NR.json": 1309,
	"./NU.json": 1310,
	"./NZ.json": 1311,
	"./OM.json": 1312,
	"./PA.json": 1313,
	"./PE.json": 1314,
	"./PF.json": 1315,
	"./PG.json": 1316,
	"./PH.json": 1317,
	"./PK.json": 1318,
	"./PL.json": 1319,
	"./PM.json": 1320,
	"./PN.json": 1321,
	"./PR.json": 1322,
	"./PS.json": 1323,
	"./PT.json": 1324,
	"./PW.json": 1325,
	"./PY.json": 1326,
	"./QA.json": 1327,
	"./RE.json": 1328,
	"./RO.json": 1329,
	"./RS.json": 1330,
	"./RU.json": 1331,
	"./RW.json": 1332,
	"./SA.json": 1333,
	"./SB.json": 1334,
	"./SC.json": 1335,
	"./SD.json": 1336,
	"./SE.json": 1337,
	"./SG.json": 1338,
	"./SH.json": 1339,
	"./SI.json": 1340,
	"./SK.json": 1341,
	"./SL.json": 1342,
	"./SM.json": 1343,
	"./SN.json": 1344,
	"./SO.json": 1345,
	"./SR.json": 1346,
	"./ST.json": 1347,
	"./SV.json": 1348,
	"./SY.json": 1349,
	"./SZ.json": 1350,
	"./TC.json": 1351,
	"./TD.json": 1352,
	"./TG.json": 1353,
	"./TH.json": 1354,
	"./TJ.json": 1355,
	"./TK.json": 1356,
	"./TL.json": 1357,
	"./TM.json": 1358,
	"./TN.json": 1359,
	"./TO.json": 1360,
	"./TR.json": 1361,
	"./TT.json": 1362,
	"./TV.json": 1363,
	"./TW.json": 1364,
	"./TZ.json": 1365,
	"./UA.json": 1366,
	"./UG.json": 1367,
	"./US.json": 1368,
	"./UY.json": 1369,
	"./UZ.json": 1370,
	"./VA.json": 1371,
	"./VC.json": 1372,
	"./VE.json": 1373,
	"./VG.json": 1374,
	"./VI.json": 1375,
	"./VN.json": 1376,
	"./VU.json": 1377,
	"./WF.json": 1378,
	"./WS.json": 1379,
	"./YE.json": 1380,
	"./YT.json": 1381,
	"./ZA.json": 1382,
	"./ZM.json": 1383,
	"./ZW.json": 1384,
	"./alt-af.json": 1385,
	"./alt-an.json": 1386,
	"./alt-as.json": 1387,
	"./alt-eu.json": 1388,
	"./alt-na.json": 1389,
	"./alt-oc.json": 1390,
	"./alt-sa.json": 1391,
	"./alt-ww.json": 1392
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;



/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json ^\.\/.*\.json$
 ** module id = 690
 ** module chunks = 0
 **/